import { useState, useEffect } from 'react';

export const usePwaInstall = () => {
  const [installPrompt, setInstallPrompt] = useState(null);

  useEffect(() => {
    const handleBeforeInstallPrompt = (event) => {
      // Prevent the default mini-infobar from appearing on mobile
      event.preventDefault();
      // Stash the event so it can be triggered later.
      setInstallPrompt(event);
    };

    // Listen for the browser's install prompt event
    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    // Cleanup the event listener when the component unmounts
    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const triggerInstall = async () => {
    if (!installPrompt) {
      return;
    }

    // Show the browser's installation prompt
    installPrompt.prompt();

    // We can't use the prompt again, so clear it
    setInstallPrompt(null);
  };

  return { isInstallable: !!installPrompt, triggerInstall };
};